export default __webpack_public_path__ + "static/media/second.40957d19.jpeg";